import React from 'react';

import AddressBlock from 'Components/AddressBlock';
import EmployerAbout from 'Components/EmployerAbout';
import EmployerCertificate from 'Components/EmployerCertificate';
import EmployerHero from 'Components/EmployerHero';
import EmployerKontakt from 'Components/EmployerKontakt';
import EmployerPartners from 'Components/EmployerPartners';
import EmployerTeam from 'Components/EmployerTeam';
import Footer from 'Components/Footer';
import Header from 'Components/Header';
import PartnersCategory from 'Components/PartnersCategory';

export default function Employer() {
  return (
    <>
      <Header />
      <EmployerHero bg='bg' overlay='dark' />
      <EmployerAbout bg='black__bgr' overlay='dark' />
      <EmployerCertificate bg='bg' overlay='dark' />
      <PartnersCategory />
      <EmployerPartners bg='black__bgr' overlay='dark' />
      <EmployerTeam bg='bg' overlay='dark' />
      <EmployerKontakt bg='black__bgr' overlay='dark' />
      <AddressBlock bg='bg' overlay='dark' />
      <Footer />
    </>
  );
}
